"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var i18next_1 = __importDefault(require("i18next"));

var config_1 = require("@navent-jobs/config");

var site_1 = require("../config/site");

var es_AR_1 = __importDefault(require("./locales/es-AR"));

var es_CL_1 = __importDefault(require("./locales/es-CL"));

var es_EC_1 = __importDefault(require("./locales/es-EC"));

var es_PA_1 = __importDefault(require("./locales/es-PA"));

var es_MX_1 = __importDefault(require("./locales/es-MX"));

var es_PE_1 = __importDefault(require("./locales/es-PE"));

var es_VE_1 = __importDefault(require("./locales/es-VE"));

var resources = {
  'es-AR': {
    translation: es_AR_1.default
  },
  'es-CL': {
    translation: es_CL_1.default
  },
  'es-EC': {
    translation: es_EC_1.default
  },
  'es-PA': {
    translation: es_PA_1.default
  },
  'es-MX': {
    translation: es_MX_1.default
  },
  'es-PE': {
    translation: es_PE_1.default
  },
  'es-VE': {
    translation: es_VE_1.default
  }
};
var whitelist = ['es', 'es-AR', 'es-CL', 'es-EC', 'es-MX', 'es-PA', 'es-PE', 'es-VE'];
var i18n = i18next_1.default.createInstance({
  fallbackLng: 'es-AR',
  debug: false,
  lng: config_1.SiteConfig[site_1.siteId].lng || 'es-AR',
  whitelist: whitelist,
  resources: resources,
  interpolation: {
    escapeValue: false
  }
}, function (err) {
  if (err) return console.log('something went wrong loading', err);
});
exports.default = i18n;